<template>
  <ul class="m-header-top__socials" aria-label="social media" v-if="props.socialMediaIcons && props.socialMediaIcons.length > 0">
    <li v-for="socialMediaIcon of props.socialMediaIcons">
      <a :href="socialMediaIcon.url" class="m-header-top__social-link" target="_blank" :title="socialMediaIcon.type.toLowerCase()">
        <svg class="a-icon a-icon--social" aria-hidden="true">
          <use :href="'#' + socialMediaIcon.type.toLowerCase()" />
        </svg>
      </a>
    </li>
  </ul>
</template>
<script setup lang="ts">
interface SocialMediaIcon {
  type: string;
  url: string;
}
const props = defineProps({
  socialMediaIcons: {
    type: Array<SocialMediaIcon>,
    default: [],
  },
})
</script>
